// state
import axios from "axios";
import commonservice from "../../shared/common.service";

const defaultState = () => ({
	entity: {
		id: null,
		contentName: null,
		firstName: null,
		lastName: null,
		email: null,
		address: null,
		countryName: null,
		mobile: null,
		query: null,
		status: null,
		response: null,
		createdDate: null,
		modifiedDate: null,
	},
});

const state = defaultState();
// getters
const getters = {};

// actions
const actions = {
	loadInquiry({}, { pagination, search }) {
		return new Promise((resolve, reject) => {
			var param = {
				descending:
					pagination.sortDesc.length > 0 ? pagination.sortDesc[0] : false,
				page: pagination.page,
				rowsPerPage: pagination.itemsPerPage,
				sortBy:
					pagination.sortBy.length > 0 ? pagination.sortBy[0] : "createdDate",
				search: search,
			};
			axios
				.get("/inquiry?" + commonservice.convertToQueryString(param))
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	setInquiry({ commit }, { id }) {
		return new Promise((resolve, reject) => {
			axios
				.get("/inquiry/" + id)
				.then((response) => {
					commit("SET_INQUIRY", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	saveInquiry({ commit, state }) {
		return new Promise((resolve, reject) => {
			if (state.entity.id) {
				axios
					.patch("/inquiry", {
						id: state.entity.id,
						response: state.entity.response,
					})
					.then(
						(response) => {
							commit("RESET");
							resolve(response);
						},
						(error) => {
							reject(error);
						}
					)
					.catch((error) => {
						reject(error);
					});
			}
		});
	},
	deleteInquiry({ commit }, { id }) {
		return new Promise((resolve, reject) => {
			axios
				.delete("/inquiry/" + id)
				.then((response) => {
					commit("RESET");
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
};

// mutations
const mutations = {
	RESET(state) {
		Object.assign(state, defaultState());
	},
	SET_INQUIRY_DATA(state, data) {
		if (Object.prototype.toString.call(state[data.key]) === "[object Array]") {
			state[data.key][data.index][data.property] = data.value;
		} else if (
			Object.prototype.toString.call(state[data.key]) === "[object Object]"
		) {
			state[data.key][data.property] = data.value;
		} else state.entity[data.key] = data.value;
	},
	SET_INQUIRY(state, data) {
		state.entity.id = data.id;
		state.entity.contentName = data.contentName;
		state.entity.firstName = data.firstName;
		state.entity.lastName = data.lastName;
		state.entity.email = data.email;
		state.entity.address = data.address;
		state.entity.countryName = data.countryName;
		state.entity.mobile = data.mobile;
		state.entity.query = data.query;
		state.entity.status = data.status;
		state.entity.response = data.response;
		state.entity.createdDate = data.createdDate;
		state.entity.modifiedDate = data.modifiedDate;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
